import { render, staticRenderFns } from "./loginAgent.vue?vue&type=template&id=548f04b4&scoped=true&"
import script from "./loginAgent.vue?vue&type=script&lang=js&"
export * from "./loginAgent.vue?vue&type=script&lang=js&"
import style0 from "./loginAgent.vue?vue&type=style&index=0&id=548f04b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548f04b4",
  null
  
)

export default component.exports